export default "__VITE_ASSET__DMmEVx7I__"